import React, { Component } from "react";
import screenfull from "screenfull";
import "./App.css";

const gradientSets = [
{ id: "gradient1_obsidian-flare", gradient: "linear-gradient(180deg, #0a0a0a, #1f1f1f, #4d4d4d, #1f1f1f, #0a0a0a, #1f1f1f, #4d4d4d, #0a0a0a, #1f1f1f, #4d4d4d, #1f1f1f, #0a0a0a, #1f1f1f, #4d4d4d, #0a0a0a, #1f1f1f, #4d4d4d, #1f1f1f, #0a0a0a, #1f1f1f, #4d4d4d, #0a0a0a, #1f1f1f, #4d4d4d, #1f1f1f, #0a0a0a, #1f1f1f, #4d4d4d, #0a0a0a, #1f1f1f, #4d4d4d, #1f1f1f, #0a0a0a, #1f1f1f, #4d4d4d, #0a0a0a, #1f1f1f, #4d4d4d, #1f1f1f, #0a0a0a, #1f1f1f, #4d4d4d)" },
{ id: "gradient2_gunmetal-glow", gradient: "linear-gradient(180deg, #111111, #2b2b2b, #5e5e5e, #2b2b2b, #111111, #2b2b2b, #111111, #2b2b2b, #5e5e5e, #2b2b2b, #111111, #2b2b2b, #111111, #2b2b2b, #5e5e5e, #2b2b2b, #111111, #2b2b2b, #111111, #2b2b2b, #5e5e5e, #2b2b2b, #111111, #2b2b2b, #111111, #2b2b2b, #5e5e5e, #2b2b2b, #111111, #2b2b2b)" },
{ id: "gradient3_silver-smoke", gradient: "linear-gradient(180deg, #0e0e0e, #1a1a1a, #666666, #1a1a1a, #0e0e0e, #1a1a1a, #666666, #0e0e0e, #1a1a1a, #666666, #1a1a1a, #0e0e0e, #1a1a1a, #666666, #0e0e0e, #1a1a1a, #666666, #1a1a1a, #0e0e0e, #1a1a1a, #666666)" },
{ id: "gradient4_carbon-dusk", gradient: "linear-gradient(180deg, #050505, #151515, #2f2f2f, #707070, #2f2f2f, #151515, #050505, #151515, #2f2f2f, #707070, #2f2f2f, #151515, #050505, #151515, #2f2f2f, #707070, #2f2f2f, #151515, #050505, #151515, #2f2f2f, #707070, #2f2f2f, #151515)" },
{ id: "gradient5_ashen-steel", gradient: "linear-gradient(180deg, #0d0d0d, #242424, #515151, #8c8c8c, #515151, #242424, #0d0d0d, #242424, #515151, #8c8c8c, #515151, #242424, #0d0d0d, #242424, #515151, #8c8c8c, #515151, #242424, #0d0d0d, #242424, #515151, #8c8c8c, #515151, #242424, #0d0d0d, #242424, #515151, #8c8c8c, #515151, #242424, #0d0d0d, #242424, #515151, #8c8c8c, #515151, #242424)" },
];

// loading functions
function buildImagesMap() {
  try {
    const ctx = require.context("./images", false, /\.gif$/);
    const map = {};
    ctx.keys().forEach((key) => {
      const m = key.match(/\.\/(\d+)\.gif$/);
      if (m) {
        const id = parseInt(m[1], 10);
        const mod = ctx(key);
        const url = mod && mod.default ? mod.default : mod;
        map[id] = url;
      }
    });
    return map;
  } catch (e) {
    return {};
  }
}

function buildTileUrls() {
  try {
    const ctx = require.context("./tiles", false, /^\.\/tile_\d+\.gif$/);
    return ctx.keys().map((key) => {
      const mod = ctx(key);
      return mod && mod.default ? mod.default : mod;
    });
  } catch (e) {
    return [];
  }
}

function buildPointerUrls() {
  try {
    const ctx = require.context("./pointers", false, /\.(png|jpe?g|gif|svg|cur|ani)$/);
    const urls = ctx.keys().map((key) => {
      const mod = ctx(key);
      const filename = key.substring(2); 
      const url = mod && mod.default ? mod.default : mod;
      return { url, filename };
    });
    return urls;
  } catch (e) {
    return [];
  }
}

function getTileName(url) {
  if (!url) return "None";
  if (url.startsWith("data:")) return "data_URL";
  const match = url.match(/tile_\d+/); // matches "tile_1", "tile_2", etc.
  return match ? match[0] : url;
}


const IMAGES = buildImagesMap();
const IMAGE_IDS = Object.keys(IMAGES).map(Number).sort((a, b) => a - b);
const TILE_URLS = buildTileUrls();
const POINTER_DATA = buildPointerUrls();
const initialTileUrl = require('./tiles/tile_0.gif'); // Preload or import

class App extends Component {
  isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|Tablet/i.test(navigator.userAgent);
  }

  lastTap = 0;

  handleDoubleTap = () => {
    const now = Date.now();
    const timeSince = now - this.lastTap;
    if (timeSince < 400 && timeSince > 0) {
      // Detected a double-tap
      this.refreshVisuals();
    }
    this.lastTap = now;
  };

  constructor(props) {
    super(props);
    
    this.updateIntervals = {};
    this.tileScrollOffset = { x: 0, y: 0 };
    this.lastFrameTime = null;
    this.scrollAnimationFrame = null;
    this.startTime = null;

    this.appRef = React.createRef();
    this.cursorRef = React.createRef();

    // Internal coordinates used when Pointer is Locked
    this.mouseX = 0;
    this.mouseY = 0;
    this.isPointerLocked = false;

    const { divCount, selectedImages, stateParts } = this.generateRandomState();

    this.state = {
      ...stateParts,
      divs: this.initializeDivs(divCount, selectedImages),
      showWelcome: true,
    };
  }

  componentDidMount() {
    if (this.isMobileDevice()) {
      window.addEventListener("touchend", this.handleDoubleTap);
    }

    this.startUpdates();
    window.addEventListener("keydown", this.handleKeyPress);
    window.addEventListener("resize", this.handleResize);
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("pointerlockchange", this.handlePointerLockChange);
    
    // Set initial mouse position to center so GIF doesn't spawn at 0,0
    this.mouseX = window.innerWidth / 2;
    this.mouseY = window.innerHeight / 2;

    this.startTileScroll();
    this.logStateTelemetry();
  }

  componentWillUnmount() {
    this.clearAllIntervals();
    window.removeEventListener("keydown", this.handleKeyPress);
    window.removeEventListener("resize", this.handleResize);
    document.removeEventListener("mousemove", this.handleMouseMove);
    document.removeEventListener("pointerlockchange", this.handlePointerLockChange);
    window.removeEventListener("touchend", this.handleDoubleTap);

    
    if (this.scrollAnimationFrame) cancelAnimationFrame(this.scrollAnimationFrame);
    if (document.pointerLockElement === this.appRef.current) {
      document.exitPointerLock();
    }
  }

  // --- POINTER LOGIC ---

  // Helper to request lock on interactions
  requestLock = () => {
    if (this.state.selectedPointerData && this.appRef.current && !this.isPointerLocked) {
      this.appRef.current.requestPointerLock().catch(e => console.log("Lock failed:", e));
    }
  }

  handleAppClick = () => {
    this.requestLock();
  };

  handlePointerLockChange = () => {
    this.isPointerLocked = (document.pointerLockElement === this.appRef.current);
  };

  // Hybrid Mouse Move Handler
  handleMouseMove = (e) => {
    if (!this.cursorRef.current || !this.state.selectedPointerData) return;

    if (this.isPointerLocked) {
      // --- LOCKED MODE (Reliable) ---
      // Use deltas
      this.mouseX += e.movementX;
      this.mouseY += e.movementY;

      // Clamp to screen (allow small padding off-screen)
      const pad = 10; 
      this.mouseX = Math.max(-pad, Math.min(window.innerWidth + pad, this.mouseX));
      this.mouseY = Math.max(-pad, Math.min(window.innerHeight + pad, this.mouseY));
    } else {
      // --- UNLOCKED MODE (Immediate on load) ---
      // Use absolute coordinates + offset to prevent browser conflict
      this.mouseX = e.clientX + 5;
      this.mouseY = e.clientY + 5;
    }

    // Apply position. CSS handles translate(-50%, -50%) centering.
    this.cursorRef.current.style.transform = 
      `translate3d(${this.mouseX}px, ${this.mouseY}px, 0) translate(-50%, -50%)`;
  };

  // --- APP LOGIC ---

  clearAllIntervals() {
    Object.values(this.updateIntervals).forEach(clearTimeout);
    this.updateIntervals = {};
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  getRandomScale() {
    return Math.random() * (1.2 - 0.1) + 0.1;
  }

  getRandomPosition() {
    return {
      top: `${this.getRandomInt(-20, 120)}%`,
      left: `${this.getRandomInt(-20, 120)}%`,
    };
  }

  closeWelcome = () => {
    this.setState({ showWelcome: false });
  };

  calculateDivCount() {
    const { innerWidth, innerHeight } = window;
    const screenArea = innerWidth * innerHeight;
    const densityDivisor = 20000;
    let count = Math.floor(screenArea / densityDivisor);
    const MAX_DIVS = 250;
    return Math.min(count, MAX_DIVS);
  }

  getUniqueRandomImages(count, idList) {
    if (!Array.isArray(idList) || idList.length === 0) return [];
    const target = Math.min(count, idList.length);
    const picked = new Set();
    while (picked.size < target) {
      picked.add(idList[this.getRandomInt(0, idList.length)]);
    }
    return Array.from(picked);
  }

  generateRandomState() {
    const divCount = this.calculateDivCount();
    const selectedGradient = gradientSets[this.getRandomInt(0, gradientSets.length)];
    const selectedImages = this.getUniqueRandomImages(divCount, IMAGE_IDS);
    
    const selectedTileUrl =
      TILE_URLS.length ? TILE_URLS[this.getRandomInt(0, TILE_URLS.length)] : null;

    const selectedPointerData =
      POINTER_DATA.length > 0 
        ? POINTER_DATA[this.getRandomInt(0, POINTER_DATA.length)] 
        : null;

    const baseAngle = this.getRandomInt(0, 360);
    const scrollSpeed = this.randomInRange(5, 40);
    const driftAmplitude = this.randomInRange(5, 25);
    const driftFrequency = this.randomInRange(0.1, 0.4);

    return {
      divCount,
      selectedImages,
      stateParts: {
        selectedGradient,
        selectedImages,
        selectedTileUrl,
        selectedPointerData,
        baseAngle,
        scrollSpeed,
        driftAmplitude,
        driftFrequency,
      }
    };
  }

  initializeDivs(count, imageIdList) {
    return Array.from({ length: count }, () => ({
      currentImage:
        imageIdList.length > 0
          ? imageIdList[this.getRandomInt(0, imageIdList.length)]
          : undefined,
      cacheBust: Date.now() + Math.random(),
      scale: this.getRandomScale(),
      position: this.getRandomPosition(),
    }));
  }

  handleResize = () => {
    const newDivCount = this.calculateDivCount();
    this.clearAllIntervals();
    const selectedImages = this.getUniqueRandomImages(newDivCount, IMAGE_IDS);
    const newDivs = this.initializeDivs(newDivCount, selectedImages);
    this.setState({ divs: newDivs, selectedImages }, () => this.startUpdates());
  };

  refreshVisuals = () => {
    // NOTE: We do NOT exit pointer lock here. 
    // If locked, stay locked. If not, stay unlocked.

    this.clearAllIntervals();
    if (this.scrollAnimationFrame) {
      cancelAnimationFrame(this.scrollAnimationFrame);
    }

    const { divCount, selectedImages, stateParts } = this.generateRandomState();

    this.tileScrollOffset = { x: 0, y: 0 };
    this.lastFrameTime = null;
    
    const tileLayer = document.querySelector(".tileLayer");
    if (tileLayer) {
      tileLayer.style.backgroundPosition = "0px 0px";
    }

    this.setState({
      ...stateParts,
      divs: this.initializeDivs(divCount, selectedImages),
    }, () => {
      this.startUpdates();
      this.startTileScroll();
      this.logStateTelemetry();
    });
  }

  logStateTelemetry() {
    const {
      selectedGradient,
      selectedImages,
      selectedTileUrl,
      selectedPointerData,
      baseAngle,
      scrollSpeed,
      driftAmplitude,
    } = this.state;

    const gradId = selectedGradient ? selectedGradient.id : "N/A";
    const imgCount = selectedImages ? selectedImages.length : 0;
    const tileStatus = selectedTileUrl ? "Active" : "None";
    const pointerName = selectedPointerData ? selectedPointerData.filename : "Default System";
    const pointerCount = POINTER_DATA.length;

    let logString = `%c--- New Visuals ---\n`;
    logString += `Gradient : ${gradId}\n`;
    logString += `Images : ${imgCount} in pool\n`;
    logString += `Pointer : ${pointerName} (${pointerCount} available)\n`;
    logString += `Tile : ${tileStatus}\n`;
    logString += `Selected Tile: ${getTileName(selectedTileUrl)}\n`;

    if (selectedTileUrl) {
    logString += `[Base: ${baseAngle.toFixed(0)}°, Drift: ±${driftAmplitude.toFixed(1)}°, Speed: ${scrollSpeed.toFixed(1)}px/s]\n`;
    }

    console.log(logString, "color: #00ddd0; font-weight: bold; line-height: 1.5;border-top: 1px solid #00ddd0; padding-top: 5px;");
  }

  handleKeyPress = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      this.refreshVisuals();
    }
    if (e.key === "f" || e.key === "F") {
      this.toggleFullScreen();
      // Keypress is a user gesture, so we can request lock here
      this.requestLock();
    }
  };

  startUpdates() {
    this.state.divs.forEach((_, index) => {
      const updateDiv = () => {
        if (!this.updateIntervals[index]) return; 

        this.setState((prevState) => {
          if (!prevState.divs[index]) return null;
          const newDivs = [...prevState.divs];
          newDivs[index] = {
            currentImage:
              prevState.selectedImages.length > 0
                ? prevState.selectedImages[
                    this.getRandomInt(0, prevState.selectedImages.length)
                  ]
                : undefined,
            cacheBust: Date.now() + Math.random(),
            scale: this.getRandomScale(),
            position: this.getRandomPosition(),
          };
          return { divs: newDivs };
        });
        this.updateIntervals[index] = setTimeout(updateDiv, this.getRandomInt(200, 2000));
      };
      this.updateIntervals[index] = setTimeout(updateDiv, this.getRandomInt(3000, 6000));
    });
  }

  startTileScroll() {
    const { baseAngle, scrollSpeed, driftAmplitude, driftFrequency, selectedTileUrl } = this.state;
    
    if (TILE_URLS.length === 0 || !selectedTileUrl) return;

    this.startTime = performance.now();
    this.lastFrameTime = null; 

    const step = (timestamp) => {
      if (!this.lastFrameTime) this.lastFrameTime = timestamp;
      const dt = (timestamp - this.lastFrameTime) / 1000;
      this.lastFrameTime = timestamp;

      const t = (timestamp - this.startTime) / 1000;
      const drift = driftAmplitude * Math.sin(2 * Math.PI * driftFrequency * t);
      const angle = baseAngle + drift;
      const rad = (angle * Math.PI) / 180;
      const vx = Math.cos(rad) * scrollSpeed;
      const vy = Math.sin(rad) * scrollSpeed;

      this.tileScrollOffset.x += vx * dt;
      this.tileScrollOffset.y += vy * dt;

      const tileLayer = document.querySelector(".tileLayer");
      if (tileLayer) {
        tileLayer.style.backgroundPosition = `${this.tileScrollOffset.x}px ${this.tileScrollOffset.y}px`;
      }

      this.scrollAnimationFrame = requestAnimationFrame(step);
    };

    this.scrollAnimationFrame = requestAnimationFrame(step);
  }

  toggleFullScreen = () => {
    if (screenfull.isEnabled && this.appRef.current) {
      screenfull.toggle(this.appRef.current);
    }
  };

  render() {
    const { selectedGradient, divs, selectedTileUrl, selectedPointerData } = this.state;

    // Immediate CSS hide via inline style
    const cursorStyle = selectedPointerData ? 'none' : 'auto';

    return (
      <div 
        className="App"
        ref={this.appRef}
        onClick={this.handleAppClick} // Click upgrades to Pointer Lock
        style={{ 
          "--bg": selectedGradient.gradient,
          cursor: cursorStyle // Applies immediately on load/refresh
        }}
      >

      {this.state.showWelcome && (
        <div className="welcome-overlay" onClick={this.closeWelcome}>
          <div className="welcome-modal" onClick={(e) => e.stopPropagation()}>
            <div className="welcome-content">
              <div className="welcome-emoji">‎𐦂𖨆𐀪𖠋</div>

                {this.isMobileDevice() ? 
                  (
                    <>
                      <p>TAP to move the cursor</p>
                      <p>DOUBLE-TAP to change things</p>
                      <p>(turn your device to see more)</p>
                    </>
                  ) : 
                  (
                    <>
                      <p>press <strong>'F'</strong> to enter fullscreen mode</p>
                      <p>CLICK anywhere to lose the little arrow</p>
                      <p>use <strong>SPACEBAR</strong> to change things</p>
                      <p>& press <strong>ESC</strong> to get out of fullscreen mode</p>
                    </>
                   )
                }
                <button className="welcome-button" onClick={this.closeWelcome}>
                  Got it!
                </button>
            </div>
          </div>
        </div>
)}


      {selectedPointerData && (
          <img 
            ref={this.cursorRef}
            src={selectedPointerData.url} 
            className="custom-cursor-element" 
            alt="" 
          />
      )}

      {selectedTileUrl && (
          <div
            className="tileLayer"
            aria-hidden="true"
            style={{
              '--tile-url': `url(${selectedTileUrl || initialTileUrl})`
            }}
         />
      )}
      
      {Array.isArray(divs) &&
          divs.map((div, index) => {
            if (!div) return null;
            const firstId = IMAGE_IDS.length ? IMAGE_IDS[0] : undefined;
            const imgUrl =
              (div.currentImage && IMAGES[div.currentImage]) ||
              (firstId ? IMAGES[firstId] : undefined);
              if (!imgUrl) return null;
              const isDataUri = typeof imgUrl === "string" && imgUrl.startsWith("data:");
              const src = isDataUri ? imgUrl : `${imgUrl}?v=${div.cacheBust}`;
              return (
               <div
                 className="theArt"
                 key={index}
                 style={{
                    top: div.position.top,
                    left: div.position.left,
                    transform: `translate(-50%, -50%) scale(${div.scale})`,
                  }}
                >
                <img
                    src={src}
                      alt=""
                      onError={(e) => {
                        e.target.onerror = null;
                        if (firstId && IMAGES[firstId]) {
                          const fallbackUrl = IMAGES[firstId];
                          const isFallbackDataUri = typeof fallbackUrl === 'string' && fallbackUrl.startsWith('data:');
                          e.target.src = isFallbackDataUri ? fallbackUrl : `${fallbackUrl}?v=${Date.now()}`;
                        }
                      }}
              />
              </div>
            );
          })}
      </div>
    );
  }
}

export default App;